import initialStates from '../storeInitialState';
import { CHECKOUT_LOADING } from '../actions/types';

const checkout = (state = initialStates.checkout, action) => {
  switch (action.type) {
    case CHECKOUT_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    default:
      return state;
  }
};

export default checkout;
